"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NATIVE_RTC_VERSION = void 0;
__exportStar(require("./generate/AgoraBase"), exports);
__exportStar(require("./generate/AgoraMediaBase"), exports);
__exportStar(require("./generate/AgoraMediaPlayerTypes"), exports);
__exportStar(require("./generate/IAgoraH265Transcoder"), exports);
__exportStar(require("./generate/IAgoraLog"), exports);
__exportStar(require("./generate/IAgoraMediaEngine"), exports);
__exportStar(require("./generate/IAgoraMediaPlayer"), exports);
__exportStar(require("./generate/IAgoraMediaPlayerSource"), exports);
__exportStar(require("./generate/IAgoraMediaRecorder"), exports);
__exportStar(require("./generate/IAgoraMediaStreamingSource"), exports);
__exportStar(require("./generate/IAgoraMusicContentCenter"), exports);
__exportStar(require("./generate/IAgoraRhythmPlayer"), exports);
__exportStar(require("./generate/IAgoraRtcEngine"), exports);
__exportStar(require("./generate/IAgoraRtcEngineEx"), exports);
__exportStar(require("./generate/IAgoraSpatialAudio"), exports);
__exportStar(require("./generate/IAudioDeviceManager"), exports);
exports.NATIVE_RTC_VERSION = '4.5.0';
